import { apiClient } from '@/libs/api'

export type FetchMonthlyTaskQuery = {
  tenantKey: string
  dcId?: number
}

export const fetchMonthlyTask = async (
  { tenantKey, dcId }: FetchMonthlyTaskQuery,
  signal?: AbortSignal
) => {
  const { data } = await apiClient._tenant(tenantKey).monthly_tasks.$get({
    query: {
      dcId
    },
    config: { signal }
  })
  return data
}
